import { TenantEntity } from '../TenantEntity'

export class FbaCharge extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
    this.className = 'FbaCharge'
  }

  get chargeItemId() {
    return this._data.chargeItemId
  }
  set chargeItemId(chargeItemId) {
    this._data.chargeItemId = chargeItemId || 0
  }
  get chargeType() {
    return this._data.chargeType
  }
  set chargeType(chargeType) {
    this._data.chargeType = chargeType || ''
  }
  get remark() {
    return this._data.remark
  }
  set remark(remark) {
    this._data.remark = remark
  }
  get currency() {
    return this._data.currency
  }
  set currency(currency) {
    this._data.currency = currency
  }
  get quotationUuid() {
    return this._data.quotationUuid
  }
  set quotationUuid(quotationUuid) {
    this._data.quotationUuid = quotationUuid
  }

  // 附加费场景
  get chargeSceneList() {
    return this._data.chargeSceneList
  }
  set chargeSceneList(chargeSceneList) {
    this._data.chargeSceneList = chargeSceneList || []
  }
}
